import { render, staticRenderFns } from "./FlexView.vue?vue&type=template&id=66900354"
import script from "./FlexView.vue?vue&type=script&lang=js"
export * from "./FlexView.vue?vue&type=script&lang=js"
import style0 from "./FlexView.vue?vue&type=style&index=0&id=66900354&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports